import { logger } from '../../utils/logging'
import { AppHTTPService } from '../http-service'

export const createAutoBuild = async (params: {
  appId: string
  environmentId: string
  formData: FormData
  empty?: boolean
}) => {
  try {
    const response = await AppHTTPService.axios.post(
      `/v1/apps/${params.appId}/autobuild?environmentId=${params.environmentId}${params.empty ? `&empty=${params.empty}` : ''}`,
      params.formData
    )
    return response.data
  } catch (error) {
    logger.error('Error in createAutoBuild:', error)
    throw error
  }
}
